import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import actorReducer from './slices/actorSlice';
import addOnsActiveReducer from './slices/addOnsActiveSlice';
import addOnsPaidReducer from './slices/addOnsPaidSlice';
import addOnsReducer from './slices/addOnsSlice';
import adminDashboardSlice from './slices/adminDashboardSlice';
import applicationReducer from './slices/applicationSlice';
import appointmentSlice from './slices/appointmentSlice';
import appSlice from './slices/appSlice';
import assetReducer from './slices/assetSlice';
import authReducer from './slices/authSlice';
import calendarNotificationSlice from './slices/calendarNotificationSlice';
import calendarReducer from './slices/calendarSlice';
import callToActionReducer from './slices/callToActionSlice';
import communicationLogReducer from './slices/communicationLogSlice';
import contactRequestSlice from './slices/contactRequestSlice';
import contactSlice from './slices/contactSlice';
import contentInstanceSlice from './slices/contentInstanceSlice';
import contentSlice from './slices/contentSlice';
import couponsReducer from './slices/couponsSlice';
import customDialogReducer from './slices/customDialogSlice';
import customerReducer from './slices/customerSlice';
import dashboardReducer from './slices/dashboardSlice';
import discountReducer from './slices/discountSlice';
import domainReducer from './slices/domainSlice';
import eventGlobalReducer from './slices/eventGlobalSlice';
import eventReducer from './slices/eventSlice';
import eventStickerReducer from './slices/eventStickerSlice';
import formReducer from './slices/formSlice';
import forwardSlice from './slices/forwardSlice';
import gameReducer from './slices/gameSlice';
import groupSlice from './slices/groupSlice';
import groupDifferenceReducer from './slices/groupDifferenceSlice';
import videoHelpReducer from './slices/helpSlice';
import icalendarFilterSlice from './slices/icalendarFilterSlice';
import icalendarProviderSlice from './slices/icalendarProviderSlice';
import appointmentV4Reducer from './slices/iCalendarV4/appointmentSlice';
import { default as availabilityV4Reducer } from './slices/iCalendarV4/availabilitySlice';
import calendarV4Reducer from './slices/iCalendarV4/calendarSlice';
import icalendarFilterV4Reducer from './slices/iCalendarV4/filterSlice';
import reminderSlice from './slices/iCalendarV4/reminderSlice';
import serviceV4Reducer from './slices/iCalendarV4/serviceSlice';
import serviceTypeV4Reducer from './slices/iCalendarV4/serviceTypeSlice';
import iCallReducer from './slices/iCallSlice';
import immersiveSlice from './slices/ImmersiveSlice';
import indexerAccountReducer from './slices/indexerAccountSlice';
import indexerApiCredentialReducer from './slices/indexerApiCredentialSlice';
import installationReducer from './slices/installationSlice';
import integrationErrorReducer from './slices/integrationErrorSlice';
import integrationLogSlice from './slices/integrationLogSlice';
import integrationsSlice from './slices/integrationsSlice';
import interactiveAppSlice from './slices/interactiveAppsSlice';
import invitationReducer from './slices/invitationSlice';
import invoiceSlice from './slices/invoiceSlice';
import labelsReducer from './slices/labelsSlice';
import launchReducer from './slices/launchSlice';
import licenseReducer from './slices/licenseSlice';
import lostOpportunitySlice from './slices/lostOpportunitySlice';
import multimediaReducer from './slices/multimediaSlice';
import myAvailabilitySlice from './slices/myAvailabilitySlice';
import nestedDialogSlice from './slices/nestedDialogSlice';
import ocalendarReducer from './slices/ocalendarSlice';
import organizationReducer from './slices/organizationSlice';
import paymentReducer from './slices/paymentSlice';
import presetsReducer from './slices/presetSlice';
import pricingSlice from './slices/pricingSlice';
import productDiscountReducer from './slices/productDiscountSlice';
import productReducer from './slices/productSlice';
import profileReducer from './slices/profileSlice';
import reactionsReducer from './slices/reactionsSlice';
import realtimeSlice from './slices/realtimeSlice';
import recordingSlice from './slices/recordingSlice';
import reportConfigSlice from './slices/reportConfigSlice';
import reportSlice from './slices/reportSlice';
import reportTypeSlice from './slices/reportTypeSlice';
import requestReducer from './slices/requestSlice';
import scriptSlice from './slices/scriptSlice';
import searchEngineReducer from './slices/searchEngineSlice';
import senderSlice from './slices/senderSlice';
import serviceReducer from './slices/serviceSlice';
import sessionsReducer from './slices/sessionsSlice';
import settingReducer from './slices/settingSlice';
import shoppableReducer from './slices/shoppableSlice';
import shortVideoSlice from './slices/shortVideoSlice';
import socialReducer from './slices/socialSlice';
import stickerReducer from './slices/stickerSlice';
import streamConnectorReducer from './slices/streamConnectorsSlice';
import systemLogReducer from './slices/systemLogSlice';
import taxonomySlice from './slices/taxonomySlice';
import templateSlice from './slices/templateSlice';
import templateTypeSlice from './slices/templateTypeSlice';
import triageSlice from './slices/triageSlice';
import tvChannelSlice from './slices/tvChannelSlice';
import unitSlice from './slices/unitSlice';
import userReducer from './slices/userSlice';
import verticalManagementSlice from './slices/verticalManagementSlice';
import webhookReducer from './slices/webhookSlice';

export default configureStore({
    reducer: {
        product: productReducer,
        asset: assetReducer,
        event: eventReducer,
        game: gameReducer,
        customDialog: customDialogReducer,
        launch: launchReducer,
        actor: actorReducer,
        calendar: calendarReducer,
        multimedia: multimediaReducer,
        organization: organizationReducer,
        auth: authReducer,
        setting: settingReducer,
        user: userReducer,
        payment: paymentReducer,
        preset: presetsReducer,
        discount: discountReducer,
        // statistics: statisticsSlice,
        reactions: reactionsReducer,
        eventSticker: eventStickerReducer,
        licenses: licenseReducer,
        customers: customerReducer,
        addOns: addOnsReducer,
        requests: requestReducer,
        addOnsActive: addOnsActiveReducer,
        profile: profileReducer,
        shoppable: shoppableReducer,
        videoHelp: videoHelpReducer,
        coupons: couponsReducer,
        addOnsPaid: addOnsPaidReducer,
        eventGlobal: eventGlobalReducer,
        streamConnectors: streamConnectorReducer,
        social: socialReducer,
        invoices: invoiceSlice,
        searchEngine: searchEngineReducer,
        indexerApiCredential: indexerApiCredentialReducer,
        indexerAccount: indexerAccountReducer,
        invitations: invitationReducer,
        integrationError: integrationErrorReducer,
        callToActions: callToActionReducer,
        dashboard: dashboardReducer,
        ocalendar: ocalendarReducer,
        sticker: stickerReducer,
        content: contentSlice,
        interactiveApp: interactiveAppSlice,
        contentInstance: contentInstanceSlice,
        triage: triageSlice,
        app: appSlice,
        realtime: realtimeSlice,
        pricing: pricingSlice,
        applications: applicationReducer,
        installations: installationReducer,
        iCalls: iCallReducer,
        labels: labelsReducer,
        communicationLog: communicationLogReducer,
        calendarNotification: calendarNotificationSlice,
        tvChannel: tvChannelSlice,
        contact: contactSlice,
        adminDashboards: adminDashboardSlice,
        scripts: scriptSlice,
        shortVideo: shortVideoSlice,
        productDiscount: productDiscountReducer,
        nestedDialog: nestedDialogSlice,
        webhook: webhookReducer,
        form: formReducer,
        group: groupSlice,
        groupDifference: groupDifferenceReducer,
        unit: unitSlice,
        taxonomy: taxonomySlice,
        service: serviceReducer,
        template: templateSlice,
        forward: forwardSlice,
        sender: senderSlice,
        domain: domainReducer,
        appointment: appointmentSlice,
        appointmentV4: appointmentV4Reducer,
        calendarV4: calendarV4Reducer,
        serviceV4: serviceV4Reducer,
        availabilityV4: availabilityV4Reducer,
        serviceTypeV4: serviceTypeV4Reducer,
        icalendarFilterV4: icalendarFilterV4Reducer,
        myAvailability: myAvailabilitySlice,
        systemLog: systemLogReducer,
        immersive: immersiveSlice,
        contactRequest: contactRequestSlice,
        lostOpportunity: lostOpportunitySlice,
        report: reportSlice,
        vertical: verticalManagementSlice,
        templateType: templateTypeSlice,
        recording: recordingSlice,
        icalendarProvider: icalendarProviderSlice,
        icalendarFilter: icalendarFilterSlice,
        integration: integrationsSlice,
        sessions: sessionsReducer,
        reminder: reminderSlice,
        reportType: reportTypeSlice,
        reportConfig: reportConfigSlice,
        integrationLog: integrationLogSlice,
    },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],
});
